<template>
  <div
    class="flex flex-wrap justify-between overflow-hidden rounded-lg px-4 py-5 sm:p-6"
    :class="[loading ? 'animate-pulse bg-neutral-99' : cardColor]"
  >
    <div
      :class="[{ 'select-none opacity-40': !active }, 'my-auto flex flex-wrap gap-4 pr-3']"
      :style="{
        flexBasis: flexBasisTextPercentage, // auto
      }"
    >
      <span v-if="loading" class="h-5 w-14 rounded-xl bg-neutral-95"></span>
      <span v-else :class="['text-xl font-semibold leading-8']">{{ percentage }}% </span>
      <div class="flex items-center gap-x-1 text-sm font-normal leading-none">
        <span v-if="loading" class="h-5 w-20 rounded-xl bg-neutral-95"></span>
        <div v-else :class="['flex items-end']">
          <UserIcon class="h-4" /> <span>{{ contactsNumber }}</span>
        </div>
      </div>
    </div>
    <!-- <span v-if="loading" class="bg-neutral-95 w-24 rounded-xl h-5"></span> -->
    <div
      v-if="!loading"
      :class="[{ 'select-none': !active }, 'my-auto flex justify-end']"
      :style="{
        flexBasis: 'auto',
      }"
    >
      <SimpleBadge theme="white" size="xlarge" square :icon="InformationCircleIcon" :tooltip="infoTooltip">
        {{ stageTitle }}
      </SimpleBadge>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

// Components
import SimpleBadge from "@atoms/SimpleBadge";
import { UserIcon, InformationCircleIcon } from "@heroicons/vue/solid";

// Types
import type { StageNames } from "@/vue/types/lifecycle";

const props = withDefaults(
  defineProps<{
    stage: StageNames;
    percentage: string;
    contactsNumber: string;
    stageTitle: string;
    infoTooltip: string;
    loading?: boolean;
    active?: boolean;
    flexBasisTextPercentage?: string;
  }>(),
  {
    loading: false,
    active: true,
    flexBasisTextPercentage: "65%",
  },
);

const cardColor = computed(() => {
  switch (props.stage) {
    case "champion":
      return "text-success-5 bg-success-90";
    case "loyalist":
      return "text-success-5 bg-success-95";
    case "recent":
      return "text-success-5 bg-success-99";
    case "highpotential":
      return "text-warning-5 bg-warning-95";
    case "neednutring":
      return "text-warning-5 bg-warning-99";
    case "cantlose":
      return "text-danger-5 bg-danger-95";
    case "atrisk":
      return "text-danger-5 bg-danger-99";
    case "abouttolose":
      return "text-danger-5 bg-danger-90";
    default:
      return "text-neutral-5 bg-neutral-95";
  }
});

// Que las tarjetas sean flex no grid, ver en el primer div que tengo grid flex -> más simple
</script>
